import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b4badee4")

_pushScopeId("data-v-b4badee4")
const _hoisted_1 = { class: "departmentalCapacity" }
const _hoisted_2 = { class: "capacity-label" }
const _hoisted_3 = { class: "capacity-content flex1 mr8" }
const _hoisted_4 = { class: "capacity-content-wrap mb29" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "添加信息", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")
  const _component_a_select = _resolveComponent("a-select")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_input_number = _resolveComponent("a-input-number")
  const _component_a_textarea = _resolveComponent("a-textarea")
  const _component_a_form = _resolveComponent("a-form")
  const _component_SvgIcon = _resolveComponent("SvgIcon")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_spin = _resolveComponent("a-spin")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_a_spin, {
      spinning: _ctx.props.loading
    }, {
      default: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.props.capacityList, (item, index) => {
          return (_openBlock(), _createBlock("div", {
            class: "departmentalCapacity-wrap flex align-items-start",
            key: item
          }, [
            _createVNode("div", _hoisted_2, "能力" + _toDisplayString(index + 1) + "：", 1),
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode(_component_a_form, {
                  model: item,
                  "label-col": _ctx.labelCol,
                  "wrapper-col": _ctx.wrapperCol
                }, {
                  default: _withId(() => [
                    _createVNode(_component_a_form_item, { label: "选择能力" }, {
                      default: _withId(() => [
                        _createVNode(_component_a_select, {
                          value: item.abilityType,
                          "onUpdate:value": ($event: any) => (item.abilityType = $event),
                          disabled: _ctx.props.disable,
                          getPopupContainer: (triggerNode) => triggerNode.parentNode
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.props.capacityDefaultList, (capacityItem) => {
                              return (_openBlock(), _createBlock(_component_a_select_option, {
                                value: capacityItem.value
                              }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(capacityItem.capacityName), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 256))
                          ]),
                          _: 2
                        }, 1032, ["value", "onUpdate:value", "disabled", "getPopupContainer"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_a_form_item, { label: "分值" }, {
                      default: _withId(() => [
                        _createVNode(_component_a_input_number, {
                          value: item.abilityScore,
                          "onUpdate:value": ($event: any) => (item.abilityScore = $event),
                          min: 0,
                          max: 10,
                          disabled: _ctx.props.disable
                        }, null, 8, ["value", "onUpdate:value", "disabled"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_a_form_item, { label: "评估反馈" }, {
                      default: _withId(() => [
                        _createVNode(_component_a_textarea, {
                          value: item.feedback,
                          "onUpdate:value": ($event: any) => (item.feedback = $event),
                          maxlength: 200,
                          disabled: _ctx.props.disable
                        }, null, 8, ["value", "onUpdate:value", "disabled"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["model", "label-col", "wrapper-col"])
              ])
            ]),
            _withDirectives(_createVNode(_component_SvgIcon, {
              class: "capacity-delete pointer",
              icon: "delete",
              onClick: ($event: any) => (_ctx.delCapacity(index))
            }, null, 8, ["onClick"]), [
              [_vShow, _ctx.isShowDel]
            ])
          ]))
        }), 128)),
        _createVNode(_component_a_button, {
          class: "capacity-addInfo user-select-none",
          onClick: _ctx.addCapacity,
          disabled: _ctx.addBtnDisable || _ctx.props.disable
        }, {
          default: _withId(() => [
            _createVNode(_component_SvgIcon, {
              class: "my-icon mr8",
              icon: "add"
            }),
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ]),
      _: 1
    }, 8, ["spinning"])
  ]))
})